import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import Card from '../components/common/Card';
import Button from '../components/common/Button';

const HomePage: React.FC = () => {
  const navigate = useNavigate();
  const [currentTime, setCurrentTime] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const formatTime = (date: Date) => {
    return date.toLocaleTimeString('ko-KR', {
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false
    });
  };

  const formatDate = (date: Date) => {
    return date.toLocaleDateString('ko-KR', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      weekday: 'long'
    });
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-4">
      <div className="w-full max-w-2xl">
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="text-center"
        >
          {/* 시간 및 날짜 표시 */}
          <Card className="mb-8">
            <motion.div
              animate={{ scale: [1, 1.05, 1] }}
              transition={{ duration: 2, repeat: Infinity }}
              className="text-4xl font-bold text-gray-800 mb-2"
            >
              {formatTime(currentTime)}
            </motion.div>
            <div className="text-lg text-gray-600">
              {formatDate(currentTime)}
            </div>
          </Card>

          {/* 환영 메시지 */}
          <Card className="mb-8">
            <motion.h1
              initial={{ opacity: 0, scale: 0.8 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ delay: 0.3, duration: 0.6 }}
              className="text-3xl font-bold text-gray-800 mb-4"
            >
              🎓 K글로벌리더아카데미
            </motion.h1>
            <motion.p
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.6, duration: 0.6 }}
              className="text-xl text-gray-700 mb-6"
            >
              에 오신 것을 환영합니다!
            </motion.p>
            <motion.p
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.9, duration: 0.6 }}
              className="text-lg text-gray-600"
            >
              오늘도 멋진 하루 되세요 ✨
            </motion.p>
          </Card>

          {/* 메뉴 버튼들 */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <motion.div
              initial={{ opacity: 0, x: -50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: 1.2, duration: 0.6 }}
            >
              <button
                onClick={() => navigate('/attendance')}
                className="w-full h-20 text-xl bg-green-600 hover:bg-green-700 text-white font-bold rounded-2xl transition-all duration-300 hover:scale-105 shadow-lg"
              >
                👨‍🎓 출석하기
              </button>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, x: 50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: 1.4, duration: 0.6 }}
            >
              <button
                onClick={() => navigate('/admin')}
                className="w-full h-20 text-xl bg-gray-800 hover:bg-gray-900 text-white font-bold rounded-2xl transition-all duration-300 hover:scale-105 shadow-lg"
              >
                ⚙️ 관리자
              </button>
            </motion.div>
          </div>

          {/* 추가 정보 */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 1.6, duration: 0.6 }}
            className="mt-8"
          >
            <Card className="bg-white/10">
              <div className="text-gray-600 text-sm">
                <p>📚 원리교육 프로그램</p>
                <p>🎯 랜덤 테이블 배정 시스템</p>
                <p>🚗 주차 관리 시스템</p>
              </div>
            </Card>
          </motion.div>
        </motion.div>
      </div>
    </div>
  );
};

export default HomePage; 